import {useTranslation} from 'react-i18next';

import {Box} from '@mui/material';

import {EmpionButton} from '../../../../components/EmpionButton/EmpionButton';

export const CompanyProfileDialogButtons = ({
  onCancel,
  onSubmit,
  isLoading,
}: {
  onCancel: () => void;
  onSubmit?: () => void;
  isLoading?: boolean;
}) => {
  const {t} = useTranslation();

  return (
    <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 3}}>
      <EmpionButton type='button' variant='secondary' onClick={onCancel}>
        {t('shared.formButtons.cancel')}
      </EmpionButton>
      <EmpionButton type='submit' variant='primary' onClick={onSubmit} disabled={isLoading}>
        {t('shared.formButtons.save')}
      </EmpionButton>
    </Box>
  );
};
